import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpRequestInterceptorService implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const l_Token = sessionStorage.getItem('jwt-token');

      if (l_Token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${l_Token}`
          }
        });
      }

      return next.handle(request);
    }
  }



// WEBPACK FOOTER //
// ./src/app/services/httpRequestInterceptor.service.ts